import ProductsPresenter from "../../listing/products/presenter/products.js";
import PaginationPresenter from "../../listing/pagination/presenter/pagination.js";
import FiltersWrapperPresenter from "../../filter/presenter/wrapper.js";
import ActionsPresenter from "../../actions/presenter/actions.js";
import ResponsiveFilterPresenter from "../../responsive-filter/presenter/responsive-filter.js";
import HeadingWrapperPresenter from "./heading-wrapper.js";
import SeoFilterPresenter from "../../seo-filter/presenter/seo-filter.js";
import LinksListPresenter from "../../links-list/presenter/links-list.js";
import SelectedPresenter from "../../selected/presenter/selected.js";

import WrapperView from "../view/wrapper.js";

import ChangeFilter from "../../change-filter/change-filter.js";
import ChangeUrl from "../../../change-url/presenter/change-url.js";
import Animation from "../../../animation/animation.js";
import ScrollToElement from "../../../scroll-to-element/scroll-to-element.js";
import PopStateNavigation from "../../browser-navigation/presenter/browser-navigation.js";

import {
  createElement,
  render,
  RenderPosition
} from "../../../render/render.js";
export default class Wrapper {
  constructor(
      wrapperElement,
      headingWrapperElement,
      breadcrumbsElement
  ) {
    this._wrapperElement = wrapperElement;
    this._headingWrapperElement = headingWrapperElement;
    this._breadcrumbsElement = breadcrumbsElement;

    this._productsPresenter = null;
    this._paginationPresenter = null;
    this._filtersWrapperPresenter = null;
    this._actionsPresenter = null;
    this._responsiveFilterPresenter = null;
    this._headingWrapperPresenter = null;
    this._seoFilterPresenter = null;
    this._linksListPresenter = null;
    this._selectedPresenter = null;

    this._wrapperView = new WrapperView(this._wrapperElement);

    this._changeFilter = new ChangeFilter();
    this._changeUrl = new ChangeUrl();
    this._animation = new Animation();
    this._scrollToElement = new ScrollToElement();
    this._browserNavigation = new PopStateNavigation(
        this._changeFilter
    );

    this._handleChangeFilterLoad = this._handleChangeFilterLoad.bind(this);
  }

  init() {
    this._productsPresenter = new ProductsPresenter(
        this._wrapperView.getProductsElement(),
        this._changeFilter
    );
    this._productsPresenter.init();

    this._paginationPresenter = new PaginationPresenter(
        this._wrapperView.getPaginationElement(),
        this._wrapperView.getProductsWrapperElement(),
        this._changeFilter,
        this._wrapperView
    );
    this._paginationPresenter.init();

    this._filtersWrapperPresenter = new FiltersWrapperPresenter(
        this._wrapperView,
        this._changeFilter,
        this._animation,
        this._scrollToElement,
        this._browserNavigation
    );
    this._filtersWrapperPresenter.init();

    this._actionsPresenter = new ActionsPresenter(
        this._wrapperView.getActionsElement(),
        this._changeFilter,
        this._browserNavigation
    );
    this._actionsPresenter.init();

    const initTotal = this._wrapperView.getInitTotal();
    this._wrapperView.removeInitTotal();

    this._responsiveFilterPresenter = new ResponsiveFilterPresenter(
        this._filtersWrapperPresenter,
        this._animation,
        this._scrollToElement,
        this._changeFilter,
        initTotal
    );
    this._responsiveFilterPresenter.init();

    this._headingWrapperPresenter = new HeadingWrapperPresenter(
        this._headingWrapperElement,
        this._animation,
        this._changeFilter
    );
    this._headingWrapperPresenter.init();

    this._initLinksList();

    this._seoFilterPresenter = new SeoFilterPresenter(
        this._headingWrapperElement,
        this._wrapperElement,
        this._breadcrumbsElement,
        this._animation,
        this._changeFilter
    );
    this._seoFilterPresenter.init();

    this._selectedPresenter = new SelectedPresenter(
        this._wrapperView,
        this._animation,
        this._changeFilter,
        this._filtersWrapperPresenter
    );
    this._selectedPresenter.init();

    this._changeFilter.addLoadObserver(this._handleChangeFilterLoad);
  }

  _initLinksList() {
    if (this._wrapperView.getLinksListElement()) {
      this._linksListPresenter = new LinksListPresenter(
          this._wrapperView.getLinksListElement(),
          this._changeFilter
      );
      this._linksListPresenter.init(true);
    }
  }

  _handleChangeFilterLoad(data) {
    if (
      data.seo_filter &&
      data.seo_filter.links_list &&
      !this._linksListPresenter
    ) {
      const linksListElement = createElement(data.seo_filter.links_list);
      render(
          this._wrapperView.getFeaturesElement(),
          linksListElement,
          RenderPosition.BEFOREBEGIN
      );

      this._initLinksList();
    }
  }
}
